import React from "react";
const icon = (
  <svg
    width="512"
    height="512"
    viewBox="0 0 512 512"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1_28)">
      <path
        d="M464 256C464 311.165 442.086 364.071 403.078 403.078C364.071 442.086 311.165 464 256 464C200.835 464 147.929 442.086 108.922 403.078C69.9142 364.071 48 311.165 48 256C48 200.835 69.9142 147.929 108.922 108.922C147.929 69.9142 200.835 48 256 48C311.165 48 364.071 69.9142 403.078 108.922C442.086 147.929 464 200.835 464 256ZM0 256C0 323.895 26.9714 389.01 74.9807 437.019C122.99 485.029 188.105 512 256 512C323.895 512 389.01 485.029 437.019 437.019C485.029 389.01 512 323.895 512 256C512 188.105 485.029 122.99 437.019 74.9807C389.01 26.9714 323.895 0 256 0C188.105 0 122.99 26.9714 74.9807 74.9807C26.9714 122.99 0 188.105 0 256ZM232 120V256C232 264 236 271.5 242.7 276L338.7 340C349.7 347.4 364.6 344.4 372 333.3C379.4 322.2 376.4 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 256 96C242.7 96 232 106.7 232 120Z"
        fill="#8803E9"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_28">
        <rect width="512" height="512" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default icon;
